import React from "react";
import {
  FiTruck,
  FiCalendar,
  FiClock,
  FiHome,
  FiPackage,
} from "react-icons/fi";

function GatePassRequestCard({ gatepass }) {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "approved":
        return "bg-green-100 text-green-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:shadow-md transition-all duration-200">
      <div className="flex items-start justify-between">
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="p-2 bg-eleghoBlue/10 rounded-lg">
              <FiTruck className="w-4 h-4 text-eleghoBlue" />
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">
                {gatepass.deliveryCompany}
              </div>
              <div className="text-xs text-gray-500">Delivery Request</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2">
              <FiHome className="w-4 h-4 text-gray-400" />
              <div>
                <div className="text-xs text-gray-500">Unit</div>
                <div className="text-sm font-medium text-gray-900">
                  {gatepass.identifier}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <FiPackage className="w-4 h-4 text-gray-400" />
              <div>
                <div className="text-xs text-gray-500">Items</div>
                <div className="text-sm font-medium text-gray-900 line-clamp-1">
                  {gatepass.items}
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <FiCalendar className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Delivery Date</div>
              <div className="text-sm font-medium text-gray-900">
                {gatepass.deliveryDate}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <FiClock className="w-4 h-4 text-gray-400" />
            <div>
              <div className="text-xs text-gray-500">Delivery Time</div>
              <div className="text-sm font-medium text-gray-900">
                {gatepass.deliveryTime}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
            gatepass.status
          )}`}
        >
          {gatepass.status}
        </div>
      </div>
    </div>
  );
}

export default GatePassRequestCard;
